// 判断页面是否为移动端
export const isMobile = () => {
  const mobileRegex =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
  return mobileRegex.test(navigator.userAgent);
};

// 设置移动端配置
export const setMobileConfig = () => {
  const flag = isMobile();
  const body = document.body;
  // body添加自定义属性
  body.setAttribute("isMobile", flag);
  if (flag) {
    const winW = window.screen.width;
    const width = 1700;
    const scale = winW / width;
    body.style.position = "absolute";
    body.style.transformOrigin = "left top";
    body.style.transform = `scaleX(${scale}) scaleY(${scale})`;
    body.style.setProperty(
      "--screen-width",
      `${window.screen.width * (width / winW)}px`
    );
    body.style.setProperty(
      "--screen-height",
      `${window.screen.height * (width / winW)}px`
    );
  } else {
    body.style.setProperty("--screen-width", `100vw`);
    body.style.setProperty("--screen-height", `100vh`);
  }
  return flag;
};
